/**
 * A chart shown in another unit than its source (PI-661). The source data is never
 * touched: the shown copy is scaled, so switching back reproduces the original.
 * An option is `{ key, unit, factor, decimals, noteKey }`.
 */

const scale = (value, factor) => (typeof value === 'number' && Number.isFinite(value) ? value * factor : value);

// ponytail: scales the point value only; min/max read-outs are derived from the shown data.
const scalePoint = (point, factor) => {
  if (Array.isArray(point)) return [point[0], scale(point[1], factor), ...point.slice(2)];
  if (point && typeof point === 'object' && 'value' in point) return { ...point, value: scale(point.value, factor) };
  return point;
};

const axesInUnit = (axes, option) =>
  axes.map((axis) => ({
    ...axis,
    unit: option.unit,
    value_format: { ...axis.value_format, decimals: option.decimals ?? axis.value_format?.decimals },
  }));

export function visualizationInUnit(visualization, option) {
  if (!visualization || !option) return visualization;
  const shown = { ...visualization };
  if (Array.isArray(visualization.axes)) shown.axes = axesInUnit(visualization.axes, option);
  if (Array.isArray(visualization.y_axes)) shown.y_axes = axesInUnit(visualization.y_axes, option);
  return shown;
}

export function chartDataInUnit(chartData, option) {
  if (!chartData?.series || !option) return chartData;
  return {
    ...chartData,
    series: chartData.series.map((series) => ({
      ...series,
      unit: option.unit,
      data: (series.data || []).map((point) => scalePoint(point, option.factor)),
    })),
  };
}

/** € per m³ (aardgasequivalent) from € per MWh gross: 35.17 MJ/m³ over 3,600 MJ/MWh. */
export const GRONINGEN_EQUIVALENT_M3 = Object.freeze({
  key: 'eur_m3',
  unit: '€/m³',
  factor: 35.17 / 3600,
  decimals: 4,
  noteKey: 'chart_units.groningen_equivalent',
});
